const TAB_ACTIVE_CLASSES = ['bg-black', 'text-white'];
const TAB_INACTIVE_CLASSES = ['bg-white', 'text-black'];

const setTabActive = (tab, active) => {
  if (active) {
    tab.classList.remove(...TAB_INACTIVE_CLASSES);
    tab.classList.add(...TAB_ACTIVE_CLASSES);
  } else {
    tab.classList.remove(...TAB_ACTIVE_CLASSES);
    tab.classList.add(...TAB_INACTIVE_CLASSES);
  }
};

const initTabbedAccordionsRoot = (root) => {
  const tabsContainer = root.querySelector('[data-faq-tabs]');
  const sentinel = root.querySelector('[data-faq-sentinel]');

  root.addEventListener('click', (event) => {
    const clickedTab = event.target.closest('.faq-tab-btn');
    if (!clickedTab || !root.contains(clickedTab)) return;

    const allTabs = root.querySelectorAll('.faq-tab-btn');
    const allPanels = root.querySelectorAll('.faq-tab-panel');

    allTabs.forEach((tab) => setTabActive(tab, tab === clickedTab));

    allPanels.forEach((panel) => panel.classList.add('!hidden'));

    const targetId = clickedTab.getAttribute('data-target');
    const targetPanel = targetId ? document.getElementById(targetId) : null;
    if (targetPanel) targetPanel.classList.remove('!hidden');
  });

  if (!sentinel || !tabsContainer) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      if (!entry.isIntersecting && entry.boundingClientRect.top < 0) {
        tabsContainer.classList.add('is-stuck');
      } else {
        tabsContainer.classList.remove('is-stuck');
      }
    },
    { threshold: 1.0 },
  );

  observer.observe(sentinel);
};

const initTabbedAccordions = () => {
  document
    .querySelectorAll('[data-tabbed-accordions]:not([data-tabbed-accordions-init])')
    .forEach((root) => {
      root.dataset.tabbedAccordionsInit = 'true';
      initTabbedAccordionsRoot(root);
    });
};

export default initTabbedAccordions;
